"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _logger = require("@insided/shared/services/logger");

var _header = _interopRequireDefault(require("../header"));

var _panel = _interopRequireDefault(require("../panel"));

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var _defaultHeader = _interopRequireDefault(require("./defaultHeader"));

var _SSIHeader = _interopRequireDefault(require("./SSIHeader"));

var _CustomHeader = _interopRequireDefault(require("./CustomHeader"));

var _api = require("../../utils/api");

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var options = [(0, _preact.h)("div", {
  key: "default"
}, (0, _preact.h)("strong", null, "Default"), (0, _preact.h)("div", null, "Use default header with configurations")), (0, _preact.h)("div", {
  key: "ssi"
}, (0, _preact.h)("strong", null, "Server Side Include (SSI) configuration"), (0, _preact.h)("div", null, "Include external HTML header via URL")), (0, _preact.h)("div", {
  key: "custom"
}, (0, _preact.h)("strong", null, "Custom code only"), (0, _preact.h)("div", null, "Add header via custom HTML"))];

var CommunityHeader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CommunityHeader, _Component);

  var _super = _createSuper(CommunityHeader);

  function CommunityHeader(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CommunityHeader);
    _this = _super.call(this, props);
    _this.state = {
      selectedOption: 0,
      defaultHeader: {
        logoUrl: '',
        label: '',
        labelMobile: '',
        url: '',
        backgroundColor: '#000',
        linkColor: '#fff'
      },
      ssiHeader: {
        url: ''
      },
      customHeader: {
        html: ''
      }
    };
    return _this;
  }

  (0, _createClass2.default)(CommunityHeader, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this;
                _context.next = 3;
                return (0, _api.getCommunityHeaderConfig)();

              case 3:
                _context.t1 = _context.sent;

                _context.t0.setStateFromBackgend.call(_context.t0, _context.t1);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "setStateFromBackgend",
    value: function setStateFromBackgend(data) {
      var type = ['default', 'ssi', 'custom'];
      this.setState({
        selectedOption: type.indexOf(data.type),
        ssiHeader: data.ssiHeader,
        customHeader: data.customHeader,
        defaultHeader: data.defaultHeader
      });
    }
  }, {
    key: "save",
    value: function () {
      var _save = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var type, updated;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  error: false,
                  success: false,
                  isLoading: true
                });
                type = 'default';
                if (this.state.selectedOption === 1) type = 'ssi';
                if (this.state.selectedOption === 2) type = 'custom';
                _context2.prev = 4;
                _context2.next = 7;
                return (0, _api.updateCommunityHeaderConfig)({
                  type: type,
                  ssiHeader: this.state.ssiHeader,
                  customHeader: this.state.customHeader,
                  defaultHeader: this.state.defaultHeader
                });

              case 7:
                updated = _context2.sent;
                _context2.next = 15;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](4);

                _logger.logger.error(_context2.t0, {
                  component: 'CommunityHeader',
                  action: 'save'
                });

                this.setState({
                  error: true,
                  isLoading: false
                });
                return _context2.abrupt("return");

              case 15:
                this.setStateFromBackgend(updated);
                this.setState({
                  success: true,
                  isLoading: false
                });

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          selectedOption = _this$state.selectedOption,
          defaultHeader = _this$state.defaultHeader,
          ssiHeader = _this$state.ssiHeader,
          customHeader = _this$state.customHeader,
          error = _this$state.error,
          success = _this$state.success,
          isLoading = _this$state.isLoading;
      /**
       * TODO: [Preact X]
       * Convert the array to Fragments
       */

      var subComponents = [(0, _preact.h)(_defaultHeader.default, (0, _extends2.default)({}, defaultHeader, {
        onChange: function onChange(newData) {
          return _this2.setState({
            defaultHeader: _objectSpread(_objectSpread({}, _this2.state.defaultHeader), newData)
          });
        }
      })), (0, _preact.h)(_SSIHeader.default, (0, _extends2.default)({}, ssiHeader, {
        onChange: function onChange(newData) {
          return _this2.setState({
            ssiHeader: _objectSpread(_objectSpread({}, _this2.state.ssiHeader), newData)
          });
        }
      })), (0, _preact.h)(_CustomHeader.default, (0, _extends2.default)({}, customHeader, {
        onChange: function onChange(newData) {
          return _this2.setState({
            customHeader: _objectSpread(_objectSpread({}, _this2.state.customHeader), newData)
          });
        }
      }))];
      return (0, _preact.h)("div", {
        className: "community-header"
      }, (0, _preact.h)(_header.default, {
        isLoading: isLoading,
        title: "Header",
        saveCallback: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _this2.save();

                case 2:
                  return _context3.abrupt("return", _context3.sent);

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))
      }), error && (0, _preact.h)(_AlertComponent.default, {
        messageType: "error",
        message: "Could not save configuration",
        renderHTML: true,
        isVisibleFor: 3000
      }), success && (0, _preact.h)(_AlertComponent.default, {
        messageType: "success",
        isVisibleFor: 3000
      }), (0, _preact.h)(_panel.default, {
        title: "Header type"
      }, (0, _preact.h)("div", {
        className: "community-header_radio-buttons"
      }, (0, _preact.h)(_RadioInputGroup.default, {
        title: "",
        options: options,
        onChange: function onChange(_, idx) {
          return _this2.setState({
            selectedOption: idx
          });
        },
        value: options[selectedOption]
      })), (0, _preact.h)("div", {
        className: "community-header_sub-component"
      }, subComponents[selectedOption])));
    }
  }]);
  return CommunityHeader;
}(_preact.Component);

var _default = CommunityHeader;
exports.default = _default;